import axios from '@/plugins/axios.js'

export function remove(orderNo) {
    return axios.delete(`order/remove/${orderNo}`);
}

export function list(params) {
    return axios.get("order/query", { params: params });
}